import { apiClient } from '../../../api/client'
import type { EmployeePick } from '../../minutes/types'
import type { AgendaDetail, AgendaListItem, AgendaRespond, AgendaScope, AgendaUpsert } from '../types'

const BASE = '/agendas'

/**
 * Ajanda uçları — sözleşme: `specs/125-ajanda-modulu/contracts/agendas-api.md` (tekrar: 126'nın
 * `contracts/agendas-series-api.md`). Takvim, kişi arama ve
 * davet yazma `AGENDA_VIEW` ister; detay ve yanıt yalnız oturum (yetkisiz davetli için). Görünürlüğü
 * sunucu çözer (görmediği toplantı `404`, sahibi olmadığında yazma `403`).
 */

/**
 * Haftalık takvim: `[from, to)` (`YYYY-MM-DD`, en çok 7 gün) ile kesişen toplantılar, başlangıca göre
 * artan. Çok günlü toplantıyı günlere istemci yerleştirir.
 */
export async function getAgendaCalendar(from: string, to: string): Promise<AgendaListItem[]> {
  const { data } = await apiClient.get<AgendaListItem[]>(`${BASE}/calendar`, { params: { from, to } })
  return data
}

export async function getAgenda(id: number): Promise<AgendaDetail> {
  const { data } = await apiClient.get<AgendaDetail>(`${BASE}/${id}`)
  return data
}

export async function createAgenda(body: AgendaUpsert): Promise<AgendaDetail> {
  const { data } = await apiClient.post<AgendaDetail>(BASE, body)
  return data
}

/**
 * Yalnız sahip; `modDate` zorunlu. Katılımcı listesi tam gönderilir, farkı sunucu çıkarır. `scope` yalnız
 * "Serinin tamamı"nda verilir (126); yoksa sunucu yalnız bu toplantıyı günceller.
 */
export async function updateAgenda(id: number, body: AgendaUpsert, scope?: AgendaScope): Promise<AgendaDetail> {
  const { data } = await apiClient.put<AgendaDetail>(`${BASE}/${id}`, body, scopeParams(scope))
  return data
}

/** Soft-delete; yalnız sahip. `scope` için bkz. {@link updateAgenda}. */
export async function deleteAgenda(id: number, scope?: AgendaScope): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`, scopeParams(scope))
}

function scopeParams(scope: AgendaScope | undefined) {
  return scope ? { params: { scope } } : undefined
}

/** Görüntüleyenin **kendi** katılım yanıtı. */
export async function respondAgenda(id: number, body: AgendaRespond): Promise<AgendaDetail> {
  const { data } = await apiClient.put<AgendaDetail>(`${BASE}/${id}/response`, body)
  return data
}

/** Katılımcı araması — tutanakla aynı İK kişi kümesi; Ajanda yetkisi (`AGENDA_VIEW`) ister. En çok 20 sonuç. */
export async function searchAgendaEmployees(q: string): Promise<EmployeePick[]> {
  const { data } = await apiClient.get<EmployeePick[]>(`${BASE}/employees`, { params: { q } })
  return data
}
